var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Icon } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import React, { Component } from "react";
import { Link } from "react-router-dom";
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Menu.prototype.render = function () {
        var visibility = "hide";
        if (this.props.menuVisibility) {
            visibility = "show";
        }
        var mobileLinks;
        if (["admin", "su"].includes(this.props.role)) {
            mobileLinks = (React.createElement("div", null,
                React.createElement("h2", null,
                    React.createElement(Link, { onClick: this.props.handleMouseDown, to: "/orders" }, "Orders")),
                React.createElement("h2", null,
                    React.createElement(Link, { onClick: this.props.handleMouseDown, to: "/users" }, "Users")),
                React.createElement("h2", null,
                    React.createElement(Link, { onClick: this.props.handleMouseDown, to: "/videos" }, "Videos")),
                React.createElement("h2", null,
                    React.createElement(Link, { onClick: this.props.handleMouseDown, to: "/devices" }, "Devices")),
                React.createElement("h2", null,
                    React.createElement(Link, { onClick: this.props.handleMouseDown, to: "/products" }, "Products")),
                React.createElement("h2", null,
                    React.createElement(Link, { onClick: this.props.handleMouseDown, to: "/enterprises" }, "Enterprises"))));
        }
        if (this.props.role === "agent") {
            mobileLinks = (React.createElement("div", null,
                React.createElement("h2", null,
                    React.createElement(Link, { onClick: this.props.handleMouseDown, to: "/orders" }, "Orders")),
                React.createElement("h2", null,
                    React.createElement(Link, { onClick: this.props.handleMouseDown, to: "/users" }, "Users")),
                React.createElement("h2", null,
                    React.createElement(Link, { onClick: this.props.handleMouseDown, to: "/videos" }, "Videos")),
                React.createElement("h2", null,
                    React.createElement(Link, { onClick: this.props.handleMouseDown, to: "/devices" }, "Devices")),
                React.createElement("h2", null,
                    React.createElement(Link, { onClick: this.props.handleMouseDown, to: "/products" }, "Products")),
                React.createElement("h2", null,
                    React.createElement(Link, { onClick: this.props.handleMouseDown, to: "/enterprises" }, "Enterprises"))));
        }
        if (this.props.role === "customer") {
            mobileLinks = (React.createElement("div", null,
                React.createElement("h2", null,
                    React.createElement(Link, { onClick: this.props.handleMouseDown, to: "/orders" }, "Orders")),
                React.createElement("h2", null,
                    React.createElement(Link, { onClick: this.props.handleMouseDown, to: "/videos" }, "Videos"))));
        }
        return (React.createElement("div", { id: "flyoutMenu", className: visibility },
            React.createElement(IconButton, { className: "menuButton", onMouseDown: this.props.handleMouseDown },
                React.createElement(Icon, { className: "menuIcon" }, "close")),
            mobileLinks));
    };
    return Menu;
}(Component));
export default Menu;



//////////////////
// WEBPACK FOOTER
// ./src/components/layout/Menu.tsx
// module id = 1010
// module chunks = 0